import { render } from "./PlayerFooter.vue?vue&type=template&id=19cfcd44&scoped=true"
import script from "./PlayerFooter.vue?vue&type=script&lang=js"
export * from "./PlayerFooter.vue?vue&type=script&lang=js"

import "./PlayerFooter.vue?vue&type=style&index=0&id=19cfcd44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cfcd44"]])

export default __exports__